export default {
    error: {
        points_program_inactive: "{$0} pausada porque utiliza el filtro \"{$1}\" vinculado al programa de puntos que está desactivado. Reactive el programa de puntos o elimine el filtro antes de reactivar.",
        points_program_inactive_trigger: "{$0} pausada porque utiliza un disparador vinculado al programa de puntos que está desactivado. Reactive el programa de puntos o cambie el disparador antes de reactivar.",
        points_program_inactive_action: "{$0} pausada porque posee una acción vinculada al programa de puntos que está desactivado. Reactive el programa de puntos o elimine la acción antes de reactivar.",
        segment_unavailable: "{$0} pausada porque utiliza el filtro \"{$1}\" que tiene errores o no está disponible. Corrija el segmento o elimine el filtro antes de reactivar.",
        generic: "Error al activar {$0}. Comuníquese con soporte si el problema continúa.",
        short: {
            points_program_inactive: "Filtro no disponible: el programa de puntos está desactivado.",
            points_program_inactive_trigger: "Disparador no disponible: el programa de puntos está desactivado.",
            points_program_inactive_action: "Acción no disponible: el programa de puntos está desactivado.",
            segment_unavailable: "Audiencia no disponible: el segmento tiene errores.",
            generic: "Error al activar {$0}.",
        },
    },
    action_names: {
        coupon: "cupón",
        feedback_link: "enlace",
        auth_link: "enlace de autenticación",
        notification: "notificación",
        add_points: "puntos",
        data_sets: "conjunto de datos",
        calculator: "calculadora",
    },
    action_alias: {
        notification: "notificacion",
        coupon: "cupon",
        cashback: "cashback",
        coupon_external: "cupon_externo",
        feedback_link: "enlace",
        add_points: "puntos",
        auth_link: "enlace_login",
        task: "tarea",
        update_field: "actualizar_campo",
        web_hook: "webhook",
        ai_content: "contenido_ia",
        move_client_stage: "mover_etapa",
        add_to_segment: "add_to_segment",
        remove_from_segment: "remove_from_segment",
        plugin_action: "accion_plugin",
        smart_insertion: "insercion",
        remove_smart_insertion: "remover",
        data_sets: "datos",
        calculator: "calculadora",
        wait: "espera",
        kevichat_internal_chat_create: "abrir_conversacion",
        kevichat_internal_chat_message: "publicar_conversacion",
    },
    triggers: {
        inactivity: "Inactividad",
        new_order: "Nuevo pedido",
        data_filled: "Perfil completado",
        reward_reached: "Recompensa alcanzada",
        feedback_received: "Opinión recibida",
        specific_date: "Programación",
        coupon_expiring: "Cupón expirando",
        birthday: "Cumpleaños",
        too_long_on_external_status: "Pedido estancado",
        joined_segment: "Entró en el segmento",
        left_segment: "Salió del segmento",
        periodic: "Periódico",
        custom_event: "Evento personalizado",
        custom_event_without_order: "Evento sin pedido",
        order_status_changed: "Estado actualizado en el pedido",
        reward_used: "Recompensa usada",
        product_group_stock: "Producto agotándose",
        enter_stage: "Entró en la etapa",
        task_moved_to_column: "Tarea movida a columna",
        quotation_status_changed: "Estado actualizado en el presupuesto",
        new_quotation: "Nuevo presupuesto",
        quotation_without_order: "Oportunidad no aprovechada",
        quotations_too_long_status: "Presupuesto estancado",
        quotation_expired: "Presupuesto expirado",
        client_date: "Fecha del cliente",
        order_status_change: "Estado actualizado en el pedido",
        manual: "Disparo manual",
    },
    goals: {
        orders: "compra",
        answers: "respuesta de formulario",
        coupons_codes: "canje de cupón",
        rewards_transactions: "canje de recompensa",
        custom_events: "evento personalizado",
    },
    list: {
        page_title: "Kevi | Acciones de Marketing",
        page_header: "Acciones de Marketing",
        add_action_button: "Añadir Acción",
        no_credits_alert: "Sus créditos se agotaron y sus automatizaciones no están funcionando.",
        low_credits_alert: "Sus créditos están por acabarse, es posible que sus automatizaciones dejen de funcionar pronto.",
        confirm_delete_title: "¿Está seguro de que desea eliminar <b>\"{$0}\"</b>?",
        confirm_delete_body: "Esta automatización dejará de funcionar una vez eliminada.",
        confirm_play_title: "¿Está seguro de que desea reanudar <b>\"{$0}\"</b>?",
        confirm_play_body: "Una vez reanudada, la automatización volverá a funcionar y podrá pausarse en cualquier momento.",
        confirm_pause_title: "¿Está seguro de que desea pausar <b>\"{$0}\"</b>?",
        confirm_pause_body: "Una vez pausada, la automatización dejará de funcionar y podrá reanudarse en cualquier momento.",
        confirm_duplicate_title: "¿Le gustaría duplicar <b>\"{$0}\"</b>?",
        confirm_duplicate_body: "Después de la duplicación, la automatización estará pausada y deberá ajustar la configuración.<br /><br />¿Desea duplicar la automatización?",
        confirm_duplicate_campaign_body: "Para evitar envíos accidentales, deberá seleccionar una nueva fecha para la campaña después de duplicar.<br /><br />¿Le gustaría duplicar la campaña?",
        campaign_label: "Campaña",
        automation_label: "Automatización",
        messages_label: "mensajes",
        purchases_label: "compras",
        answers_label: "respuestas",
        conversions_label: "conversiones",
        play_success: "¡Acción iniciada con éxito!",
        pause_success: "¡Acción pausada con éxito!",
        action_error: "¡Ocurrió un error al ejecutar esta acción!",
        duplicate_success: "¡Automatización duplicada con éxito!",
        filters: {
            period: "Periodo",
            title: "Título de la automatización",
            type: "Tipo",
            type_campaigns: "Campañas",
            type_automations: "Automatizaciones",
            status: "Status",
            status_active: "Activas",
            status_paused: "Pausadas",
            status_deleted: "Eliminadas",
        },
        aria: {
            edit_automation: "Editar automatización {$0}",
            actions_group: "Acciones para {$0}",
            duplicate_automation: "Duplicar automatización {$0}",
            report_automation: "Informe de automatización {$0}",
            resume_automation: "Reanudar automatización {$0}",
            pause_automation: "Pausar automatización {$0}",
            remove_automation: "Eliminar automatización {$0}",
        },
        tooltip: {
            duplicate: "Duplicar automatización",
            report: "Informe de automatización",
            edit: "Editar automatización",
            remove: "Eliminar automatización",
            resume: "Reanudar automatización",
            pause: "Pausar automatización",
        },
    },
    form: {
        page_title: "Kevi | Automatizaciones",
        editing_warning: "Por su seguridad, esta acción no se ejecutará mientras está editando.",
        trigger_points_program_inactive_warning: "Esta automatización utiliza un disparador vinculado al programa de puntos, que está desactivado. Para que vuelva a funcionar, reactive el programa de puntos o cambie el disparador.",
        filter_points_program_inactive_warning: "Esta automatización utiliza el filtro de saldo de puntos, pero el programa de puntos está desactivado. Elimine el filtro o reactive el programa de puntos para poder activar la automatización.",
        segment_with_error: "con error",
        confirm_overwrite_title: "\"{$0}\" estaba editando esta automatización recientemente y puede que sobrescriba su trabajo.",
        confirm_overwrite_body: "¿Desea continuar de todas formas?",
        confirm_edit_active_title: "Esta campaña ya comenzó, ¿desea cambiar sus datos?",
        confirm_edit_active_body: "Una vez inicializada, editarla puede causar envíos duplicados.",
        title_new: "Añadir",
        title_edit: "Editar",
        title_page_suffix: "Acción",
        title_label: "Título",
        title_help: "Elija un título para identificar su acción",
        goal_label: "Objetivo",
        goal_help: "¿Cuál es el objetivo de esta campaña?",
        select: "Seleccione",
        goals: {
            orders: "Generar pedido",
            answers: "Obtener opinión",
            custom_event_clients: "Ejecutar evento personalizado",
            loyalty_points_earned: "Ganar puntos de fidelidad",
            reward_redemptions: "Canje de recompensa",
        },
        select_option: "Seleccione una de las Opciones",
        any_option: "Cualquiera de las Opciones",
        conversion_period_help: "¿Cuál es el período de conversión (en días)?",
        zero_days: "0 días",
        trigger_label: "Disparador",
        trigger_help: "Elija el disparador que iniciará la acción",
        triggers: {
            inactivity: "Inactividad",
            new_order: "Nuevo pedido",
            order_status_change: "Estado actualizado en el pedido",
            product_group_stock: "Producto agotándose",
            periodic: "Fecha Periódica",
            too_long_on_external_status: "Pedido estancado",
            client_date: "Fecha del cliente",
            data_filled: "Perfil completado",
            custom_event: "Realizó Evento Personalizado",
            custom_event_without_order: "Evento sin pedido",
            coupon_expiring: "Cupón expirando",
            reward_reached: "Alcanzar recompensa",
            reward_used: "Recompensa utilizada",
            feedback_received: "Nueva opinión",
            joined_segment: "Entró en el segmento",
            left_segment: "Salió del segmento",
            enter_stage: "Entró en la etapa",
            task_moved_to_column: "Tarea movida a columna",
            birthday: "Cumpleaños",
            manual: "Disparo manual",
            specific_date: "Campaña",
            new_quotation: "Nuevo presupuesto",
            quotation_status_change: "Estado actualizado en el presupuesto",
            quotations_too_long_status: "Presupuesto estancado",
            quotation_expired: "Presupuesto expirado",
            quotation_without_order: "Oportunidad no aprovechada",
        },
        action_modal: {
            identification_label: "Identificación:",
            identification_help: "Elija un id para esta acción, lo que escriba aquí podrá ser usado para acceder a propiedades de esta acción en notificaciones futuras en esta misma automatización.",
            identification_error: "La identificación debe tener un máximo de 25 caracteres",
            identification_duplicate_error: "Por favor elija una identificación que aún no haya sido utilizada.",
            cancel_button: "Cancelar",
            add_button: "Añadir",
        },
        add_action_modal_title: "Añadir Acción",
        action_types: {
            generate_coupon: "Generar Cupón",
            generate_coupon_tray: "Generar Cupón en Tray",
            generate_coupon_shopify: "Generar Cupón en Shopify",
            calculate_cashback: "Calcular Cashback",
            generate_feedback_link: "Generar Enlace de Opinión",
            generate_auth_link: "Generar Enlace de Autenticación",
            generate_notification: "Generar Notificación",
            add_points: "Añadir Puntos",
            add_task: "Añadir Tarea",
            update_client_field: "Actualizar información del cliente",
            webhook: "WebHook",
            generate_ai_content: "Generar contenido con IA",
            move_client_stage: "Mover al cliente en el viaje",
            add_to_segment: "Agregar al segmento",
            remove_from_segment: "Eliminar del segmento",
            smart_insertion: "Inserción Inteligente",
            remove_smart_insertion: "Eliminar Inserción",
            select_data_sets: "Seleccionar Conjunto de Datos",
            calculator: "Calculadora",
            wait: "Esperar",
            new_notification: "Nueva Notificación",
        },
        filter_audience_title: "Filtre el público de la acción",
        audience_label: "Público:",
        configure_actions_title: "Configurar Acciones",
        add_button: "Añadir",
        action_config_help: "¿Qué acciones deben ejecutarse cuando se ejecute el flujo?",
        confirm_delete_action_title: "¿Está seguro de que desea eliminar la acción {$0}?",
        confirm_delete_action_body: "Esta acción dejará de funcionar una vez eliminada.",
        confirm_save_campaign_title: "Esta campaña se enviará a todos sus clientes.",
        confirm_save_campaign_body: "¿Está seguro de que desea continuar?",
        saving: "Guardando...",
        save_and_activate: "Guardar y Activar",
        save_draft: "Guardar como borrador",
        a_user: "Un usuario",
        save_error_message: "Error al guardar la automatización.",
        filters: {
            avg_ticket: "Ticket promedio",
            orders_amount: "Número de pedidos",
            customer_profile: "Perfil del cliente",
            profile_complete: "Con registro completo",
            profile_incomplete: "Sin registro completo",
            points_balance: "Saldo de Puntos",
            client_segments: "Segmento del cliente",
            client_segments_not: "No está en segmento",
            last_order_period: "Período del último pedido",
            min_period_between_execution: "Tiempo mínimo entre ejecuciones",
            branch: "Sucursales",
            last_branch: "Sucursal del último pedido",
            clients_limit: "Límite de clientes",
            value: "Valor",
            period_between_executions: {
                label: "Días",
                suffix: "días",
                check_label: "Verificar:",
                check_options: {
                    this: "Esta automatización",
                    all: "Cualquier automatización",
                },
                close_button: "Cerrar",
                not_informed: "No informado",
                check_suffix: {
                    all: " ( todas ) ",
                    this: " ( esta )",
                },
            },
        },
        actions: {
            auth_link: {
                title: "Generar un enlace de autenticación",
                description: "Crea un enlace que lleva al cliente ya autenticado al área del cliente, donde podrá consultar sus puntos y cupones.",
            },
            add_points: {
                title: "Añadir puntos al cliente",
                description: "Esta acción le permite añadir puntos al perfil del cliente en el que se ejecuta.",
                points_label: "¿Cuántos puntos quieres añadir?",
                use_snippets_label: "Usar etiquetas de sustitución en este campo",
                snippet_placeholder: "Ej.: [[calculadora.resultado]]",
                snippets_help: "Elija una etiqueta que resulte en un número. El valor se redondea y, si es cero o negativo, no se añaden puntos:",
            },
            cashback: {
                title: "Calcular Cashback",
                description: "Calcular el valor de cashback para el cliente.",
                percentage_label: "¿Qué % de esta compra quieres devolver al cliente?",
                max_discount_label: "Valor máximo del descuento en %",
                simulation_button_open: "Cerrar simulación",
                simulation_button_closed: "Simular cashback",
                example_value_label: "Valor de compra del cliente en $",
                example_text: "Ejemplo: Si el cliente compra <strong>${$0}</strong> recibirá <strong>${$1}</strong> en cashback para usar en compras superiores a <strong>${$2}</strong>",
            },
            coupon: {
                title: "Generar un cupón",
                description: "Crear un nuevo cupón de descuento para el cliente.",
                validity_label: "¿Cuál es la validez del cupón?",
                validity_unit: "Días",
                min_wait_label: "¿Tiempo mínimo para el uso?",
                min_wait_help: "¿Cuál es el tiempo mínimo que el cliente debe esperar antes de poder utilizar este cupón?",
                min_wait_unit: "Horas",
                calculation_label: "¿Cómo se calcula el valor del cupón?",
                calculation_options: {
                    fixed_amount: "Valor fijo",
                    percentage: "Descuento en porcentaje",
                    cashback: "Cashback",
                    other: "Otros",
                },
                discount_label: "¿Cuál es el valor de descuento del cupón?",
                use_snippets_label: "Usar etiquetas de sustitución en este campo",
                min_purchase_label: "Valor mínimo de compra",
                cashback_percentage_label: "¿Qué % de esta compra quieres devolver al cliente?",
                cashback_max_discount_label: "Valor máximo del descuento en %",
                cashback_example_text: "Ejemplo: Si el cliente compra <strong>${$0}</strong> recibirá <strong>${$1}</strong> en cashback para usar en compras superiores a <strong>${$2}</strong>",
                description_label: "Descripción del cupón para el cliente",
                snippets_help: "Puede usar las siguientes etiquetas de sustitución inteligente en su solicitud:",
                token_copied: "¡Token copiado con éxito!",
            },
            coupon_external: {
                title: "Generar un cupón",
                description: "{$0} en pedidos superiores a {$1}",
                validity_label: "¿Cuál es la validez del cupón? (En días)",
                calculation_label: "¿Cómo se calcula el valor del cupón?",
                calculation_options: {
                    fixed_amount: "Monto fijo",
                    percentage_amount: "Porcentual",
                    cashback: "Cashback",
                },
                fixed_amount_label: "¿Cuál es el valor del cupón?",
                percentage_amount_label: "¿Cuál es el descuento del cupón?",
                cashback_percentage_label: "¿Qué % de esta compra quieres devolver al cliente?",
                cashback_max_discount_label: "Valor máximo del descuento en %",
                min_purchase_label: "Valor mínimo de compra",
                discount_scope_label: "¿Dónde se aplica el descuento en Shopify?",
                discount_scope_help: "Pedido es el predeterminado. Producto se aplica solo a los ítems y puede combinarse con un descuento de pedido.",
                discount_scope_options: {
                    order: "Descuento de pedido",
                    product: "Descuento de producto",
                },
            },
            task: {
                title: "Generar una tarea para el equipo",
                description: "Crear una nueva tarea para que la realice un miembro del equipo.",
                snippets_help: "Puede usar las siguientes etiquetas de sustitución inteligente en todos los campos de la tarea:",
                board_label: "¿En qué tablero?",
                board_placeholder: "Seleccione un tablero",
                task_title_label: "Título de la tarea",
                deadline_label: "Plazo de la tarea (en días)",
                description_label: "Descripción",
                has_message_suggestion_label: "Añadir sugerencia de mensaje",
                use_ai_label: "Utilizar IA para generar mensaje",
                message_suggestion_label: "Sugerencia de Mensaje",
                ai_prompt_label: "Explique cómo debe ser el mensaje.",
                ai_prompt_help: "El mensaje sugerido se generará utilizando inteligencia artificial. Alimentaremos a la IA con el historial de compras del cliente y los datos del cliente.",
                responsible_label: "Responsable",
                responsible_help: "¿Quién debe ser el responsable de la tarea?",
                assign_methods: {
                    manual: "Seleccionar manualmente",
                    by_role: "Distribuir por cargo",
                    by_custom_field: "Campo del cliente",
                },
                role_label: "Cargo",
                role_placeholder: "Seleccionar cargo",
                branch_label: "Sucursal",
                branch_rules: {
                    last: "Última visitada",
                    first: "Primera visitada",
                    all: "Todas",
                },
                custom_field_label: "Campo del cliente",
                custom_field_placeholder: "Seleccionar campo del cliente",
                user_label: "Usuario",
                user_placeholder: "Seleccionar usuario",
                token_copied: "¡Token copiado con éxito!",
            },
            update_field: {
                title: "Actualizar campos del cliente",
                description: "Actualice dinámicamente la información del cliente.",
                snippets_help: "Puede utilizar las siguientes etiquetas de sustitución inteligente en los campos:",
                field_label: "¿Qué campo desea actualizar?",
                field_placeholder: "Seleccione el campo",
                update_rule_label: "¿Cómo actualizar?",
                update_rules: {
                    always_replace: "Reemplazar siempre",
                    set_if_empty: "Rellenar si está vacío",
                },
                fill_rule_distribute: "Distribuir por cargo",
                fill_rule_order_field: "Rellenar con campo de pedido",
                fill_rule_manual: "Informar manualmente",
                distribute_help: "El usuario se seleccionará aleatoriamente según los siguientes filtros:",
                branch_label: "Sucursal",
                branch_placeholder: "Seleccione una opción",
                branch_options: {
                    any: "Cualquiera",
                    last: "Sucursal del último pedido",
                    first: "Sucursal del primer pedido",
                },
                role_label: "Cargo",
                role_placeholder: "Seleccione una opción",
                role_any: "Cualquiera",
                select_option_placeholder: "Seleccione una opción",
                value_label: "¿Cuál es el valor?",
                add_field_button: "Añadir Campo",
                token_copied: "¡Token copiado con éxito!",
                user_manual_label: "¿Qué usuario?",
                user_manual_help: "Informe el id o el correo electrónico de un usuario, o una etiqueta de sustitución que resulte en uno de ellos. Si el valor no corresponde a un usuario activo, el paso falla.",
                user_manual_pick_user: "O elija un usuario para rellenar el id",
            },
            web_hook: {
                title: "Ejecutar WebHook",
                description: "Esta acción realiza una llamada POST a la URL informada.",
                url_label: "¿Qué URL desea llamar?",
                request_body_title: "Cuerpo de la solicitud",
                field_key_label: "Campo (clave)",
                field_key_placeholder: "Ej: nombre",
                field_value_label: "Valor",
                field_value_placeholder: "Ej: [[cliente.nombre]]",
                add_field_button: "Añadir campo",
            },
            ai_content: {
                title: "Generar contenido con IA",
                description: "Esta acción le permite generar contenido automáticamente con inteligencia artificial.",
                model_label: "¿Qué modelo de inteligencia artificial desea utilizar?",
                models: {
                    basic: "Básico (Recomendado)",
                    advanced: "Avanzado",
                },
                credits_label: "Créditos: {$0}",
                basic_description: "<strong>Básico:</strong> Adecuado para la mayoría de los escenarios, pero puede tener dificultades para seguir instrucciones complejas. Mayor riesgo de alucinación.",
                advanced_description: "<strong>Avanzado:</strong> Es un modelo más preciso, con capacidad para adaptarse a instrucciones más complejas y con menor riesgo de alucinación. Permite devolver múltiples valores (por ejemplo: mensaje, imagen, cupón) para su uso en las próximas acciones de la automatización. Sin embargo, el costo por ejecución es mayor. Recomendamos utilizarlo solo cuando el modelo básico no produzca un resultado adecuado para usted.",
                prompt_label: "¿Qué necesita? (Prompt)",
                prompt_help: "Describa el contenido que desea como si se lo estuviera pidiendo a un empleado que conoce todo el historial de este cliente.",
                placeholder: "Ej: Escribe un mensaje para [[cliente.nombre]] ofreciendo un 10% de descuento con el código [[cupon.codigo_descuento]]. Preséntate como Fulano de la Empresa X. Utiliza un tono cercano y amigable.",
                snippets_help: "Puede utilizar las siguientes etiquetas de sustitución inteligente en su solicitud:",
                footer_help: "Además de poder usar los tokens anteriores, su solicitud se alimentará con los datos del cliente, el historial de compras y las opiniones.",
                advanced_settings_label: "Configuraciones avanzadas",
                output_values_label: "Valores de salida adicionales",
                output_values_help: "Defina campos adicionales que la IA debe devolver además del contenido principal. Cada campo estará disponible como token en las próximas acciones de la automatización. Ej: URL de una imagen, código de cupón, etc.",
                field_id_placeholder: "Identificador (ej: imagen)",
                field_instruction_placeholder: "Instrucción para la IA (ej: URL de la imagen del producto)",
                remove_field_title: "Eliminar campo",
                add_field_button: "Añadir campo",
            },
            move_client_stage: {
                title: "Mover al cliente en el viaje",
                description: "¿A qué etapa debemos mover al cliente?",
            },
            segment_membership: {
                segment_label: "Segmento:",
                segment_placeholder: "Seleccione un segmento",
                loading_segments: "Cargando segmentos...",
            },
            add_to_segment: {
                title: "Agregar al segmento",
                description: "¿A qué segmento manual se debe agregar este cliente?",
            },
            remove_from_segment: {
                title: "Eliminar del segmento",
                description: "¿De qué segmento manual se debe eliminar este cliente?",
            },
            smart_insertion: {
                title: "Inserción inteligente",
                description: "Esta acción le permite ejecutar una inserción inteligente en el perfil del cliente.",
                insertion_name_label: "Nombre de la inserción",
                insertion_name_help: "El nombre de la inserción se utiliza para identificar la inserción al desactivarla mediante programación. Puede utilizar tokens de sustitución en el nombre.",
                space_label: "¿Dónde desea realizar la inserción?",
                duration_label: "Duración (días)",
                edit_html_button: "Editar HTML",
            },
            remove_smart_insertion: {
                title: "Eliminar inserción inteligente",
                description: "Esta acción le permite eliminar una inserción inteligente del perfil del cliente.",
                space_label: "¿De dónde desea realizar la inserción?",
                space_options_any: "En cualquier lugar",
                insertion_name_label: "Nombre de la inserción",
                insertion_name_help: "El nombre de la inserción se utiliza para identificar la inserción al desactivarla mediante programación. Puede utilizar tokens de sustitución en el nombre.",
            },
            data_sets: {
                title: "Seleccionar conjunto de datos",
                description: "Esta acción le permite crear fragmentos a partir de datos de su conjunto de datos.",
                dataset_label: "¿Qué conjunto de datos desea utilizar?",
                selection_mode_label: "¿Cómo desea seleccionar la clave?",
                selection_modes: {
                    ai: "Seleccionar con IA",
                    manual: "Informar manualmente",
                },
                key_label: "¿Qué clave desea consultar?",
                snippets_help: "Puede utilizar las siguientes etiquetas de sustitución inteligente en la construcción de claves:",
                ai_credits: "Créditos: {$0}",
                ai_prompt_label: "Instrucción para que la IA seleccione la clave:",
                ai_prompt_placeholder: "Ingrese los criterios para que la IA seleccione la clave más adecuada...",
                ai_prompt_help: "La IA analizará los datos del cliente y el conjunto de datos para seleccionar la clave más adecuada en función de la instrucción.",
            },
            wait: {
                title: "Esperar",
                description: "Pause la automatización por un período de tiempo antes de continuar con la siguiente acción.",
                duration_label: "¿Cuánto tiempo esperar?",
                duration_help: "La automatización se pausará por este tiempo antes de ejecutar la siguiente acción.",
                days: "Días",
                hours: "Horas",
                minutes: "Minutos",
            },
            calculator: {
                title: "Calculadora",
                description: "Calcula un valor a partir de una fórmula con datos de la automatización. El resultado queda disponible para las siguientes acciones.",
                formula_label: "Fórmula matemática",
                syntax_valid: "Sintaxis válida",
                syntax_error: "Error de sintaxis",
                insert: "Insertar:",
                formula_placeholder: "Ej: (a + b) * 0.10",
                help_operators: "Operadores disponibles:",
                help_decimals: "Usa punto para decimales (ej: 10.5).",
                help_functions: "Las funciones reciben los valores entre paréntesis, separados por coma. Ej:",
                fn_max: "Mayor valor entre los argumentos",
                fn_min: "Menor valor entre los argumentos",
                fn_round: "Redondea al entero más cercano",
                fn_abs: "Valor absoluto (sin signo)",
                fn_floor: "Redondea hacia abajo",
                fn_ceil: "Redondea hacia arriba",
                open_parenthesis: "Abrir paréntesis",
                close_parenthesis: "Cerrar paréntesis",
                variables_label: "Mapeo de variables",
                variables_empty: "Escribe una fórmula con letras para configurar las variables. Ej:",
                mapping_label: "Mapear a variable del sistema",
                mapping_placeholder: "Ej: [[pedido.{$0}]]",
                mapping_invalid: "Formato obligatorio:",
                example_label: "Valor de prueba",
                preview_title: "Vista previa de la simulación",
                interpretation: "Interpretación:",
                waiting_formula: "Esperando fórmula...",
                result_label: "Resultado calculado:",
                error: "Error",
                error_invalid_result: "Resultado inválido (división por cero o indefinido).",
                error_syntax: "Error de sintaxis. Verifica paréntesis y operadores.",
                error_decimal_comma: "Usa punto para decimales (ej: 0.5). La coma solo separa valores dentro de funciones, como max(a, b).",
            },
            feedback_link: {
                title: "Generar un enlace para el formulario",
                description: "Cree un nuevo enlace único para que el cliente pueda enviar su opinión.",
                form_label: "Formulario:",
                form_error: "Por favor, seleccione un formulario.",
                form_help: "Elija uno para esta acción, el formulario que seleccione aquí se utilizará para generar un enlace que se enviará en esta misma automatización, y sus clientes responderán a las preguntas contenidas en él.<br />Solo se enumerarán los formularios que contengan preguntas.",
                select_form_placeholder: "Seleccione un Formulario",
            },
            plugin: {
                use_snippets_label: "Usar etiquetas de reemplazo en este campo",
                select_placeholder: "Seleccione",
                select_parent_first: "Elija primero el campo de arriba",
                select_empty: "No se encontró nada",
                snippets_help: "Puede utilizar las siguientes etiquetas de sustitución inteligente:",
                token_copied: "¡Token copiado con éxito!",
            },
            notification: {
                title: "Enviar notificación",
                description: "Envía una notificación al cliente por SMS, correo electrónico o WhatsApp.",
                content_label: "Contenido",
                schedule_label: "Horarios de envío:",
                schedule_help: "Respetar o no las configuraciones de horario definidas en el menú <a href='/#/notification-schedule' target='_blank'>Configuraciones > Horários de envío de notificaciones</a>",
                schedule_options: {
                    from_place: "Respetar configuraciones de horario",
                    anytime: "Enviar en cualquier momento",
                },
                timeout_label: "Esperar:",
                timeout_help: "¿Cuánto tiempo esperar después de la acción anterior para enviar esta notificación? (En minutos)",
                timeout_placeholder: "Ej: 10",
                method_label: "¿Enviar vía?",
                method_help: "Si se elige el método de correo electrónico y el cliente no tiene un correo electrónico configurado, la notificación no se enviará.",
                method_placeholder: "Seleccione el método",
                recipient_label: "Enviar a:",
                recipient_help: "Por defecto la notificación se envía al contacto del propio cliente. Elija \"Otro\" para enviar a una dirección fija o definida por etiquetas de reemplazo.",
                recipient_options: {
                    client_phone: "Teléfono del cliente",
                    client_email: "Correo electrónico del cliente",
                    custom_phone: "Otro teléfono",
                    custom_email: "Otro correo electrónico",
                },
                recipient_address_label_phone: "Teléfono de destino:",
                recipient_address_label_email: "Correo electrónico de destino:",
                recipient_address_placeholder_phone: "Ej: +5511999999999 o [[cliente.telefone]]",
                recipient_address_placeholder_email: "Ej: contacto@empresa.com o [[cliente.email]]",
                recipient_address_help: "Puede utilizar las etiquetas de reemplazo listadas abajo. Si el valor final queda vacío, la notificación no se enviará.",
                recipient_address_required_error: "Informe la dirección de destino.",
                sender_label: "Disparar por:",
                sender_placeholder: "Seleccione el disparador",
                sender_default: "Disparador estándar",
                no_default_sender: "Ninguno configurado",
                no_default_sender_warning: "Ningún disparador estándar configurado. Haga clic en la etiqueta junto al disparador para ",
                configure_default_sender_link: "definir un disparador estándar",
                template_placeholder: "Seleccione la plantilla",
                wpp_cloud: {
                    header: "Encabezado:",
                    image_preview: "Vista previa de la imagen de ejemplo:",
                    image_url_label: "{$0} - URL de la imagen:",
                    header_preview_video: "Vista previa del video de ejemplo:",
                    header_preview_document: "Encabezado con documento (ejemplo de la plantilla):",
                    header_preview_gif: "Vista previa del GIF de ejemplo:",
                    header_media_url_video: "{$0} - URL del video:",
                    header_media_url_document: "{$0} - URL del documento:",
                    header_media_url_gif: "{$0} - URL del GIF:",
                    header_document_example_hint:
                        "Esta plantilla usa un documento en el encabezado. Use un enlace https:// público, una extensión conocida (p. ej. PDF) o una etiqueta inteligente. No hay vista previa visual.",
                    document_url_accepted_hint:
                        "URL aceptada para el envío. WhatsApp usará este enlace como medio del encabezado del documento.",
                    document_filename_label: "Nombre del archivo (opcional)",
                    document_filename_help:
                        "Nombre opcional que verá el destinatario. Déjelo vacío para usar el predeterminado del enlace.",
                    document_filename_placeholder: "ej.: factura.pdf",
                    invalid_document_url_error:
                        "Ingrese una URL http(s) válida o un enlace cuya ruta termine en una extensión de documento conocida (ej.: .pdf).",
                    location_header_label: "Ubicación (encabezado)",
                    location_latitude_label: "Latitud",
                    location_latitude_placeholder: "ej.: -23.5505",
                    location_longitude_label: "Longitud",
                    location_longitude_placeholder: "ej.: -46.6333",
                    location_name_label: "Nombre del lugar",
                    location_name_placeholder: "ej.: Tienda centro",
                    location_address_label: "Dirección",
                    location_address_placeholder: "Dirección completa",
                    upload_button: "Subir aquí",
                    validating_media: "Validando medios...",
                    custom_media_preview: "Vista previa de su {$0}:",
                    media_types: {
                        image: "imagen",
                        video: "video",
                        document: "documento",
                    },
                    required_error: "Este campo debe ser completado",
                    video_not_supported: "Su navegador no soporta el elemento de video.",
                    body: "Cuerpo:",
                    body_help: "El contenido del mensaje es fijo para cada plantilla, pero puede completar las variables a continuación:",
                    footer: "Pie de página:",
                    buttons: "Botones:",
                    buttons_label: "Botón ({$0}):",
                    quick_reply: "Respuesta rápida: {$0}",
                    call_phone: "Llamar al teléfono: {$0} ({$1})",
                    visit_website: "Visitar sitio: {$0} ({$1})",
                    marketing_opt_out: "Marketing Opt-Out: {$0}",
                    coupon_code: "Código de cupón: {$0}",
                    invalid_video_error: "URL de video no válida o video no encontrado",
                    invalid_image_error: "URL no válida o imagen no encontrada",
                    timeout_video_error: "Tiempo de espera agotado: asumiendo URL de video válida",
                    timeout_url_error: "Tiempo de espera agotado: asumiendo URL válida",
                    url_empty_error: "URL vacía",
                    smart_tag_valid_success: "Etiqueta de reemplazo inteligente identificada con éxito",
                    smart_tag_not_found_error: "Etiqueta de reemplazo inteligente no encontrada en la lista de tokens disponibles",
                    statuses: {
                        approved: "Aprobado",
                        rejected: "Rechazado",
                        pending: "Pendiente",
                    },
                },
                whatsapp: {
                    sender_number_label: "¿Enviar por qué número?",
                    selection_help: "Elija un disparador específico de WhatsApp, use el campo del cliente o la última sucursal visitada.",
                    select_manually: "Seleccionar manualmente",
                    instance_placeholder: "Seleccionar una instancia",
                    client_field: "Campo del cliente",
                    select_client_field: "Seleccionar campo del cliente",
                    custom_field_fallback_help: "Nota: si el usuario obtenido por este campo no tiene un disparador de WhatsApp vinculado, se usará el Disparador estándar.",
                    last_branch: "Última sucursal visitada",
                    last_branch_fallback_help: "Nota: si la última sucursal visitada no tiene un disparador de WhatsApp vinculado, se usará el Disparador estándar.",
                    message_placeholder: "Mensaje",
                    send_file_label: "Enviar archivo, foto o video.",
                    file_url_placeholder: "URL del archivo/video",
                    upload_help: "Subir aquí",
                    validating_media: "Validando medios...",
                    preview_label: "Vista previa {$0}:",
                    media_types: {
                        image: "de su imagen",
                        video: "de su video",
                    },
                    video_not_supported: "Su navegador no soporta el elemento de video.",
                    required_error: "Este campo debe ser completado",
                    file_url_limit_error: "La URL del archivo no puede tener más de 240 caracteres",
                },
                email: {
                    subject_label: "Asunto del correo electrónico:",
                    subject_placeholder: "Asunto",
                    content_label: "Contenido del correo electrónico:",
                    edit_content_button: "Editar contenido",
                    edit_html_button: "Editar HTML",
                },
                sms: {
                    accents_help: "*Se eliminarán todos los acentos.",
                },
                rcs: {
                    type_label: "Tipo de mensaje RCS",
                    type: {
                        basic: "Texto corto",
                        single: "Texto (hasta 1000 caracteres)",
                        card: "Card",
                        carousel: "Carrusel",
                        file: "Archivo",
                    },
                    text_help: "RCS mantiene los acentos. El texto corto usa la ruta basic; los textos más largos usan single.",
                    image: "URL pública de la imagen",
                    title: "Título",
                    message: "Mensaje",
                    button: "Botón",
                    button_text: "Texto del botón",
                    button_url: "URL del botón (opcional)",
                    add_button: "Agregar botón",
                    button_text_required: "Un botón con enlace necesita un texto. Sin el texto, el enlace no se envía.",
                    card: "Card",
                    add_card: "Agregar card",
                    file: "URL pública del archivo",
                    file_name: "Nombre del archivo",
                },
                common: {
                    snippets_help: "Puede utilizar las siguientes etiquetas de sustitución inteligente en el contenido:",
                    token_copied: "¡Token copiado con éxito!",
                },
            },
        },
        triggers_config: {
            birthday: {
                description: "Este disparador se activará cuando un cliente esté a punto de cumplir años.",
                threshold_label: "¿Ejecutar cuántos días antes del cumpleaños? (Deje 0 para enviar el día del cumpleaños)",
            },
            client_date: {
                description: "Este disparador se activa en función de la fecha de un campo del cliente.",
                field_label: "¿Cuál es el campo de fecha?",
                field_placeholder: "Seleccione el campo",
                when_options: {
                    before: "Enviar antes de {$0}",
                    after: "Enviar después de {$0}",
                    at_date: "Enviar en el día exacto de {$0}",
                },
                threshold_label: "¿Cuántos días {$0} de {$1}?",
                threshold_options: {
                    before: "antes",
                    after: "después",
                },
                yearly_label: "Enviar anualmente en la misma fecha (ideal para cumpleaños)",
            },
            coupon_expiring: {
                description: "Este disparador se activará cuando un cupón esté a punto de caducar.",
                threshold_label: "¿Ejecutar cuántos días antes de que caduque?",
            },
            data_filled: {
                description: "Este disparador se activará cuando sus clientes completen sus datos.",
            },
            enter_stage: {
                description: "Esta automatización se activará cuando el cliente entre en la etapa seleccionada o en alguna etapa secundaria.",
                modal_title: "¿Mover a qué etapa?",
                close_button: "Cerrar",
                select_stage_button: "Seleccionar etapa",
            },
            task_moved_to_column: {
                description:
                    "Esta automatización se activará cuando una tarea se mueva a una de las columnas seleccionadas del tablero.",
                board_label: "¿Qué tablero?",
                board_placeholder: "Seleccione el tablero",
                column_label: "Columna(s) de destino",
                no_columns: "Este tablero no tiene columnas.",
            },
            feedback_received: {
                description: "Este disparador se activará cuando sus clientes completen un formulario de opinión.",
                form_label: "¿Qué formulario?",
                all_forms: "Todos",
                when_label: "¿Cuándo ejecutar?",
                when_options: {
                    all: "En todas las opiniones",
                    greater: "Con promedio superior a x",
                    lower: "Con promedio inferior a x",
                },
                x_label: "X = ?",
                greater_help: "¿Con qué promedio superior desea ejecutar esta automatización para la opinión?",
                lower_help: "¿Con qué promedio inferior desea ejecutar esta automatización para la opinión?",
            },
            inactivity: {
                description: "Este disparador se activará cuando sus clientes permanezcan un período x sin realizar pedidos.",
                days_label: "Tiempo sin pedidos (en días):",
            },
            joined_segment: {
                description: "Este disparador se activará cuando sus clientes pasen a formar parte de un nuevo segmento.",
                segment_label: "¿Qué segmento?",
                segment_placeholder: "Seleccione el segmento",
                loading_segments: "Cargando segmentos...",
            },
            left_segment: {
                description: "Este disparador se activará cuando sus clientes dejen de formar parte de un segmento.",
                segment_label: "¿Qué segmento?",
                segment_placeholder: "Seleccione el segmento",
                loading_segments: "Cargando segmentos...",
            },
            manual: {
                description: "Este disparador se activa manualmente desde la pantalla del cliente o mediante una solicitud a la API.",
                fields_label: "Campos del disparo",
                fields_help: "Cada campo se convierte en un elemento del formulario en la pantalla del cliente y en un snippet que puede usar en las acciones. Use solo letras minúsculas, números y _.",
                name_placeholder: "nombre_del_campo",
                types: {
                    text: "Texto",
                    number: "Número",
                    date: "Fecha",
                    boolean: "Sí/No",
                },
                required_label: "Obligatorio",
                add_field_button: "Agregar campo",
                remove_field_title: "Eliminar campo",
                copy_snippet_title: "Copiar snippet",
                api_title: "Disparar mediante la API",
                api_unsaved: "Guarde la automatización para ver las instrucciones de la API con su ID.",
                api_help: "Autentíquese con el token Bearer de su integración. El cliente se identifica por id, correo, teléfono o nombre, y se creará si no existe.",
                api_docs_link: "Ver documentación completa",
                api_copy_button: "Copiar ejemplo",
                error_key_required: "Informe el nombre del campo.",
                error_key_duplicated: "Este nombre ya se usa en otro campo.",
            },
            new_order: {
                description: "Este disparador se activará cuando sus clientes realicen un nuevo pedido.",
                when_label: "¿Cuándo ejecutar?",
                when_options: {
                    all: "En todos los pedidos",
                    every: "Cada x pedidos",
                    greater: "Cada pedido después de x",
                    lower: "Cada pedido antes de x",
                    exact: "En el pedido número x",
                },
                x_label: "X = ?",
                every_help: "¿Cada cuántos pedidos quieres realizar esta automatización?",
                exact_help: "¿En qué pedido quieres realizar esta acción? ¿1? ¿5?",
                filter_value_label: "Filtrar pedidos por valor.",
                min_value_label: "Valor mínimo",
                max_value_label: "Valor máximo",
                filter_field_label: "Filtrar pedidos por {$0}.",
                checkbox_tooltip: "Se aplican uno o más.",
                placeholder_equal: "Cuando sea igual a...",
            },
            new_quotation: {
                description: "Este disparador se activará cuando se cree un nuevo presupuesto.",
                when_label: "¿Cuándo ejecutar?",
                when_options: {
                    all: "En todos los presupuestos",
                    every: "Cada x presupuestos",
                    greater: "Cada presupuesto después de x",
                    lower: "Cada presupuesto antes de x",
                    exact: "En el presupuesto número x",
                },
                x_label: "X = ?",
                every_help: "¿Cada cuántos presupuestos quieres realizar esta automatización?",
                exact_help: "¿En qué presupuesto quieres realizar esta acción? ¿1? ¿5?",
                filter_value_label: "Filtrar presupuestos por valor.",
                min_value_label: "Valor mínimo",
                max_value_label: "Valor máximo",
                filter_field_label: "Filtrar presupuestos por {$0}.",
                placeholder_equal: "Cuando sea igual a...",
            },
            order_status_change: {
                description: "Este disparador se activará cuando un pedido cambie de estado.",
                status_label: "¿En qué estado ejecutar?",
                all_status: "En todos los estados",
                filter_value_label: "Filtrar pedidos por valor.",
                min_value_label: "Valor mínimo",
                max_value_label: "Valor máximo",
                filter_field_label: "Filtrar pedidos por {$0}.",
                placeholder_value: "Valor...",
                filter_options: {
                    equals: "Cuando sea igual a...",
                    contains: "Cuando contenga...",
                    not_contains: "Cuando no contenga...",
                    any_value: "Cuando exista valor",
                    no_value: "Cuando no exista valor",
                },
            },
            periodic: {
                description: "Este disparador se activará en ciclos periódicos.",
                send_monthly: "Enviar mensualmente",
                send_weekly: "Enviar semanalmente",
                at_label: "a las",
                week_days: {
                    mon: "Lun",
                    tue: "Mar",
                    wed: "Mié",
                    thu: "Jue",
                    fri: "Vie",
                    sat: "Sáb",
                    sun: "Dom",
                },
            },
            product_group_stock: {
                description: "Este disparador se activará cuando el stock de un grupo de productos de su cliente esté a punto de agotarse.",
                group_label: "¿Qué grupo de productos?",
                group_placeholder: "Seleccione el grupo de productos",
                any_group: "Cualquier grupo",
                loading_groups: "Cargando grupos...",
                threshold_label: "¿Ejecutar cuántos días antes de que se agote el stock? (Deje 0 para enviar el día que se agote)",
            },
            quotation_expired: {
                description: "Este disparador se activa en función de la fecha de vencimiento de los presupuestos abiertos.",
                when_options: {
                    before: "Enviar antes de la fecha de vencimiento",
                    after: "Enviar después de la fecha de vencimiento",
                    at_date: "Enviar el día exacto de la fecha de vencimiento",
                },
                threshold_label: "¿Cuántos días {$0} de la fecha de vencimiento ?",
                threshold_options: {
                    before: "antes",
                    after: "después",
                },
            },
            quotation_status_change: {
                description: "Este disparador se activará cuando un presupuesto cambie de estado.",
                status_label: "¿En qué estado ejecutar?",
                all_status: "En todos los estados",
                filter_value_label: "Filtrar presupuestos por valor.",
                min_value_label: "Valor mínimo",
                max_value_label: "Valor máximo",
                filter_field_label: "Filtrar presupuestos por {$0}.",
                placeholder_equal: "Cuando sea igual a...",
            },
            quotation_without_order: {
                description: "Este disparador se activará cuando un cliente tenga un presupuesto, sin ningún pedido después del mismo.",
                time_label: "¿Exactamente hace cuánto tiempo?",
                time_placeholder: "Ej: 7",
                unit_label: "Unidad",
                units: {
                    days: "Días",
                    hours: "Horas",
                    minutes: "Minutos",
                },
                status_label: "¿Con qué estado del presupuesto?",
                all_status: "Todos los estados",
            },
            quotations_too_long_status: {
                description: "Este disparador se activará cuando un cliente tenga un presupuesto estancado en un determinado estado durante más de x días.",
                status_label: "¿Cuál es el estado?",
                days_label: "¿Estancado hace cuántos días?",
                no_status_help: "Debe registrar los estados externos para configurar este activador.",
            },
            reward_reached: {
                description: "Este disparador se activará cuando sus clientes alcancen los puntos necesarios para canjear una recompensa.",
            },
            reward_used: {
                description: "Este disparador se activará cuando sus clientes utilicen una recompensa específica.",
                reward_label: "¿Qué recompensa?",
                any_reward: "Cualquiera",
            },
            specific_date: {
                description: "Esta automatización se activará cuando la fecha coincida con su configuración de programación.",
                date_label: "Fecha y hora:",
            },
            too_long_on_status: {
                description: "Este disparador se activará cuando un cliente tenga un pedido estancado en un determinado estado durante más de x días.",
                status_label: "¿Cuál es el estado?",
                days_label: "¿Estancado hace cuántos días?",
                filter_orders_label: "Filtrar pedidos por {$0}.",
                filter_types: {
                    equals: "Cuando sea igual a...",
                    contains: "Cuando contenga...",
                    not_contains: "Cuando no contenga...",
                    any_value: "Cuando exista valor",
                    no_value: "Cuando no exista valor",
                },
                value_placeholder: "Valor...",
                no_event_help: "Debe registrar los eventos personalizados para configurar este activador.",
            },
            custom_event: {
                description: "Este disparador se activará cuando sus clientes realicen un evento personalizado.",
                event_label: "¿Qué evento?",
                event_placeholder: "Buscar evento...",
                when_label: "¿Cuándo ejecutar?",
                when_options: {
                    all: "En todas las ejecuciones",
                    every: "Cada x ejecuciones",
                    exact: "En la ejecución número x",
                },
                x_label: "X = ?",
                every_help: "¿Cada cuántas ejecuciones quieres realizar esta automatización?",
                exact_help: "¿En qué ejecución quieres realizar esta acción? ¿1? ¿5?",
            },
            custom_event_without_order: {
                description: "Este disparador se activará cuando el último evento personalizado coincidente del cliente (por ejemplo, una visita a una página de producto) sea más antiguo que el tiempo configurado y no se haya realizado ningún pedido después de él.",
                match_label: "¿Cómo identificar el evento?",
                match_options: {
                    exact: "Un evento personalizado específico",
                    starts_with: "El título del evento empieza con",
                    contains: "El título del evento contiene",
                },
                event_label: "¿Qué evento?",
                event_placeholder: "Buscar evento...",
                title_label: "Título del evento",
                title_placeholder: "Ej: Entrou no site - https://tienda.com/producto",
                title_help: "Coincide con eventos de acceso por su título. Usa la URL o un fragmento de la ruta de la página del producto.",
                time_label: "¿Exactamente hace cuánto tiempo?",
                time_placeholder: "Ej: 2",
                unit_label: "Unidad",
                units: {
                    days: "Días",
                    hours: "Horas",
                    minutes: "Minutos",
                },
                cooldown_note: "Este disparador se ejecuta como máximo una vez por cliente cada 24 horas.",
            },
        },
    },
    reach_report: {
        title: "Análisis RFM",
        frequency_monetary_axis: "Promedio entre frecuencia y monetario",
        recency_axis: "Recencia",
        last_purchase_label: "Última compra",
        to: "a",
        purchases: "compras",
        made_in_last_days: "Realizadas en los últimos {$0} días",
        spent_range: "${$0} a ${$1}",
        spent_in_last_days: "Gastado en los últimos {$0} días",
        col_client: "Cliente",
        col_phone: "Teléfono",
        col_email: "E-mail",
        col_recency: "Recencia",
        col_frequency: "Frecuencia",
        col_monetary: "Monetario",
        col_rfm_score: "RFM Score",
    },
    report: {
        created_at: "FECHA DE CREACIÓN:",
        reactivated: "reactivados",
        reactivated_tooltip_part1: "Un cliente inactivo es un cliente que lleva más de 60 días sin comprar.",
        reactivated_tooltip_part2: "Es decir, {$0} clientes llevaban más de 60 días sin comprar y compraron después de recibir esta automatización.",
        converted_clients_label: "Clientes convertidos",
        conversions_label: "Conversiones",
        financial_return_label: "Retorno financiero",
        avg_ticket_label: "Ticket promedio",
        conversion_rate_label: "Tasa de conversión",
        table_title: "Clientes convertidos",
        col_name: "Nombre",
        col_receipt_date: "Fecha de recepción",
        col_order_date: "Fecha de pedido",
        col_value: "Valor",
        col_days_since_prev: "Días desde el pedido anterior",
        col_orders_after: "Pedidos después de la automatización",
        unidentified: "(No identificado)",
        chart_same_day: "El mismo día",
        chart_one_day_after: "1 día después",
        chart_n_days_after: "{$0} días después",
        chart_orders_label: "Pedidos después de recibir la automatización",
    },
};
